__turbopack_context__.v({
  "container": "Quote-module-scss-module__CQUSPq__container",
  "offsetLeft": "Quote-module-scss-module__CQUSPq__offsetLeft",
  "offsetRight": "Quote-module-scss-module__CQUSPq__offsetRight",
  "quote": "Quote-module-scss-module__CQUSPq__quote",
});
